import { render, staticRenderFns } from "./duedayAlarm.vue?vue&type=template&id=b83bdfaa&scoped=true"
import script from "./duedayAlarm.vue?vue&type=script&lang=js"
export * from "./duedayAlarm.vue?vue&type=script&lang=js"
import style0 from "./duedayAlarm.vue?vue&type=style&index=0&id=b83bdfaa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83bdfaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83bdfaa')) {
      api.createRecord('b83bdfaa', component.options)
    } else {
      api.reload('b83bdfaa', component.options)
    }
    module.hot.accept("./duedayAlarm.vue?vue&type=template&id=b83bdfaa&scoped=true", function () {
      api.rerender('b83bdfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/duedayAlarm.vue"
export default component.exports